import React, { useEffect, useState } from 'react';
import axios from '../../api/axios';
import Select from "react-select";
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const NewExpenses = () => {
    const { expensesId } = useParams()
    const navigate = useNavigate()
    const [categoryOption, setcategoryOption] = useState([])
    const [banks, setBanks] = useState([]);
    const [state, setState] = useState({ category_id: null, amount: 0, note: '', bank_id: null })
    const [errors, setErrors] = useState({});

    const getCategoryData = () => {
        axios.get("/expenses/expense-categories").then((res) => {
            const categoryOption = res.data.map(item => ({ value: item.id, label: item.name }));
            setcategoryOption(categoryOption);
        });
    }
    const getbankData = () => {
        axios.get('/banks').then(res => {
            const bankOption = res.data.map(item => ({ value: item.id, label: item.name }));
            setBanks(bankOption)
        });
    }
    const validateForm = () => {
        const newErrors = {};
        if (!state.amount) newErrors.amount = "amount is required";
        if (!state.bank_id) newErrors.bank_id = "bank is required";
        if (!state.category_id) newErrors.category_id = "category is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    useEffect(() => {
        if (expensesId) {
            axios.get(`/expenses/${expensesId}`).then((res) => {
                setState({ ...state, category_id: Number(res.data?.category), amount: res.data.amount, note: res.data?.note, bank_id: res.data?.bank_id })
                console.log(res.data);
            });
        }
    }, [expensesId])
    useEffect(() => {
        getCategoryData()
        getbankData()
    }, [])
    const handleSubmit = (e) => {
        e.preventDefault()
        if (!validateForm()) return;

        const payload = {
            category_id: state.category_id,
            amount: Number(state.amount),
            note: state.note,
            bank_id: state.bank_id
        }
        const apiUrl = expensesId
            ? `/expenses/${expensesId}`  // Update endpoint
            : '/expenses';           // Create endpoint

        const apiCall = expensesId
            ? axios.put(apiUrl, payload)                   // Use PUT for update
            : axios.post(apiUrl, payload);                 // Use POST for create

        apiCall
            .then(res => {
                if (res.data.success === true) {
                    toast.success(res.data?.message || `Expenses ${expensesId ? 'updated' : 'created'} successfully!`)
                    const timer = setTimeout(() => {
                        navigate('/expenses-list')
                    }, 2000);
                    return () => clearTimeout(timer);
                } else {
                    toast.error(res.data?.message || `Expenses ${expensesId ? 'updated' : 'created'} successfully!`)
                }
            })
            .catch(err => toast.error(err.message || `Error`));
    }
    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <h2 className="text-xl font-bold mb-4">Expenses — Add/Update</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label className="font-semibold text-sm !mt-4">Supplier Name *</label>
                        <Select
                            name="Supplier"
                            options={categoryOption}
                            placeholder="Select Category"
                            value={categoryOption.find(c => c.value === state.category_id) || null}
                            onChange={e => {
                                setState({ ...state, category_id: e.value })
                                if (errors.category_id) setErrors(prev => ({ ...prev, category_id: null }));
                            }}
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                            className={errors.category_id ? 'border border-red-500 mt-1' : ''}
                        />
                        {errors.category_id && <p className="text-red-500 text-xs">{errors.category_id}</p>}
                    </div>
                    <div>
                        <label className="font-semibold text-sm">Payment Bank</label>
                        <Select
                            name="paymentBank"
                            options={banks}
                            value={banks.find(v => v.value === state.bank_id) || null}
                            placeholder="Select Bank"
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                            onChange={e => {
                                setState({ ...state, bank_id: e.value })
                                if (errors.bank_id) setErrors(prev => ({ ...prev, bank_id: null }));
                            }}
                            className={errors.bank_id ? 'border border-red-500  mt-1' : ''}
                        />
                        {errors.bank_id && <p className="text-red-500 text-xs">{errors.bank_id}</p>}
                    </div>
                    <div>
                        <label className="font-semibold text-sm">Expenses Amount</label>
                        <input
                            type="text"
                            value={state?.amount}
                            placeholder='Enter amount'
                            onChange={(e) => {
                                setState({ ...state, amount: e.target.value })
                                if (errors.amount) setErrors(prev => ({ ...prev, amount: null }))
                            }}
                            className={errors.amount ? 'border-red-500 border w-full rounded mt-1' : 'border w-full rounded mt-1'}
                        />
                        {errors.amount && <p className="text-red-500 text-xs">{errors.amount}</p>}
                    </div>
                    <div>
                        <label className="font-semibold text-sm">Expenses Note</label>
                        <input
                            type="text"
                            value={state?.note}
                            placeholder='Enter note'
                            onChange={(e) => setState({ ...state, note: e.target.value })}
                            className="border w-full rounded mt-1"
                        />
                    </div>
                </div>
                <div className="flex justify-center items-center gap-4 mt-4">
                    <button type='submit' className=" bg-green-600 hover:bg-green-700 text-white px-8 py-2 rounded">Save</button>
                    <button type="button" onClick={() => navigate('/expenses-list')} className="bg-gray-400 hover:bg-gray-500 text-white px-8 py-2 rounded">Close</button>
                </div>
            </form>
        </div>
    );
};

export default NewExpenses;